<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { CriteriaSurveyEmailSenderViewModel } from "@Evaluation/CriteriaSurveys/Components/CriteriaSurveyEmailSender";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriteriaSurveyEmailSender extends Vue
    {
        get vm(): CriteriaSurveyEmailSenderViewModel { return this.$props.viewModel as CriteriaSurveyEmailSenderViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get numberOfRecipients(): number { return this.vm.projectUserIds.length; }
        get emailBodyError(): string { return this.EmailBody.indexOf("{url}") === -1 ? "{url} is required in the message. " : null; }
        get emailSubjectError(): string { return this.EmailSubject ? null : "Email subject is required"; }
        get hasErrors(): boolean { return this.emailSubjectError != null || this.emailBodyError != null; }

        EmailSubject: string = "Please complete this survey";
        EmailBody: string = "Please click on the following link to complete your survey: {url}";

        handleSendEmail()
        {
            this.$emit("send-email", this.EmailSubject, this.EmailBody);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>

    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Send email ({{numberOfRecipients}})</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Subject:</label>
                                <input type="text" class="form-control" v-model.trim="EmailSubject">
                                <div class="error">{{emailSubjectError}}</div>
                            </div>
                            <div class="form-group">
                                <textarea rows="5" class="form-control" v-model.trim="EmailBody"></textarea>
                                <div class="error">{{emailBodyError}}</div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                        <button @click="handleSendEmail" :disabled="hasErrors" type="button" class="btn btn-primary">Send email</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>